import React from "react";
import { observer } from "mobx-react";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { SubtitleDescription } from "../../subtitleDescription";
import commonStyles from "../../../../containers/settings/settingsEditCommon.css";
import { ExistingMappingFormType } from "./types";
import { TaggingSettingsList } from "./taggingSettingsList";
import { SettingsListFilterProvider } from "../../settingsForms/filters/useListFilter/useListFilter";
import { withPreloading } from "../../../HOC/withPreloading/withPreloading";
import { withPermissionFallback } from "../../../HOC/withPermissionFallback/withPermissionFallback";
import { AppPermission } from "@closerplatform/spinner-openapi";

const TaggingSettingsComponent = observer(() => {
  return (
    <>
      <div className={commonStyles.title}>
        <L10n id={"settings.admin.tagging"} />
      </div>
      <div className={commonStyles.section}>
        <SubtitleDescription
          subtitle={intl.formatMessage("settings.tagging.tags.subtitle")}
          description={intl.formatMessage("settings.tagging.tags.description")}
        />
        <div className={commonStyles.content}>
          <SettingsListFilterProvider<ExistingMappingFormType>>
            <TaggingSettingsList />
          </SettingsListFilterProvider>
        </div>
      </div>
    </>
  );
});

export const TaggingSettings = withPermissionFallback<{}>(
  AppPermission.SettingsTags,
  withPreloading(TaggingSettingsComponent)
);
